import { render, staticRenderFns } from "./PlacesTable.vue?vue&type=template&id=522a7207"
import script from "./PlacesTable.vue?vue&type=script&lang=ts"
export * from "./PlacesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports